import { render, staticRenderFns } from "./SelectTags.vue?vue&type=template&id=4978bf4a"
import script from "./SelectTags.vue?vue&type=script&lang=js"
export * from "./SelectTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports